import React, { useEffect, useState } from "react";
import {
  cancelOrderController,
  changeOrderStatusController,
  orderLogListController,
  refundPaymentController,
  updateOrderRemark,
  updateTransactionIdController,
  viewOrderController,
} from "../../services/orderServices/orderListController";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  dateFormatYear,
  dateTimeFormat,
  showDateFormatYear,
  timeFormat,
} from "../../utility/utils";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import ModalBox from "../../common/ModalBox";
import useButtonLoader from "../../hooks/useButtonLoader";

function ViewOrder() {
  const { id } = useParams();
  const [orderDetail, setOrderDetail] = useState([]);
  const [orderSummary, setOrderSummary] = useState({});
  const [schemeDetail, setSchemeDetail] = useState([]);
  const [orderStatus, setOrderStatus] = useState();
  const [statusModal, setStatusModal] = useState(false);
  const [CancelledModal, setCancelledModal] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [cancelDescription, setCancelDescription] = useState("");
  const [cancelDescriptionModal, setCancelDescriptionModal] = useState(false);
  const navigate = useNavigate();
  const [submitButton, setSubmitButton] = useButtonLoader("", "Please wait...");
  const [trackingId, setTrackingId] = useState("");
  const [orderStatusModal, setOrderStatusModal] = useState(false);
  const [orderHistory, setOrderHistory] = useState([]);
  const [errors, setErrors] = useState("");
  const [refundModal, setRefundModal] = useState(false);
  const [transactionId, setTransactionId] = useState(""); // State for new transaction ID
  const [transactionIdModal, setTransactionIdModal] = useState(false);
  const [orderRemarkModal, setOrderRemarkModal] = useState(false);
  const [orderRemark, setOrderRemark] = useState("");
  const [masterOrderId, setMasterOrderId] = useState(null);
  const [invoiceFile, setInvoiceFile] = useState(null);
  const [invoiceError, setInvoiceError] = useState("");
  const [search, setSearch] = useState("");
  const [filterByDate, setFilterByDate] = useState("");
  const [totalLogs, setTotalLogs] = useState();
  const role = localStorage.getItem("role");
  const isAdmin = role === "admin" ? true : false;

  const fetchViewOrder = async () => {
    try {
      const response = await viewOrderController(id);
      if (response?.code === 200) {
        setOrderSummary(response?.data?.orderSummary);
        setSchemeDetail(response?.data?.orderSummary?.usedScheme);
        setOrderDetail(response?.data?.orderSummary?.orderDetail);
        setMasterOrderId(response?.data?.orderSummary?.masterOrderId);

        let orderStatusArray = [];

        if (response?.data?.orderSummary?.createdAt) {
          orderStatusArray.push({
            orderStatus: "Approved",
            date: showDateFormatYear(response?.data?.orderSummary?.createdAt),
            time: timeFormat(response?.data?.orderSummary?.createdAt),
          });
        }

        if (response?.data?.orderSummary?.shippedDate) {
          orderStatusArray.push({
            orderStatus: "Shipped",
            date: showDateFormatYear(response?.data?.orderSummary?.shippedDate),
            time: timeFormat(response?.data?.orderSummary?.shippedDate),
          });
        }

        if (response?.data?.orderSummary?.deliveredDate) {
          orderStatusArray.push({
            orderStatus: "Delivered",
            date: showDateFormatYear(
              response?.data?.orderSummary?.deliveredDate
            ),
            time: timeFormat(response?.data?.orderSummary?.deliveredDate),
          });
        }

        if (response?.data?.orderSummary?.rejectedDate) {
          orderStatusArray.push({
            orderStatus: "Cancelled",
            date: showDateFormatYear(
              response?.data?.orderSummary?.rejectedDate
            ),
            time: timeFormat(response?.data?.orderSummary?.rejectedDate),
          });
        }
        setOrderHistory(orderStatusArray);
      } else {
        toast.error(response?.message);
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  const fetchingOrderLogs = async () => {
    const response = await orderLogListController(
      1,
      1000,
      search ? search : "",
      filterByDate ? dateFormatYear(filterByDate) : "",
      id ? id : ""
    );
    if (response?.code === 200) {
      setTotalLogs(response?.data?.data);
    } else {
      toast.error(response?.message);
    }
  };

  // Cancel Reason Field Validation
  const cancelReasonValidation = () => {
    let validationStatus = true;
    let error = "";
    if (!cancelReason) {
      error = "Reason for cancellation is mandatory*";
      validationStatus = false;
    }
    setErrors(error);
    return validationStatus;
  };

  // order status handler
  const orderStatusHandler = (e) => {
    const { value } = e.target;
    setOrderStatus(value);
    if (Number(value) === 2) {
      setStatusModal(true);
    } else if (Number(value) === 4) {
      setCancelledModal(true);
    } else {
      setOrderStatusModal(true);
    }
  };
  const invoiceValidation = () => {
    const validFileTypes = ["application/pdf"];
    let validationStatus = true;
    const error = {};
  
    // Validate tracking ID (if status is "Shipped")
    if (orderStatus === "2" && !trackingId) {
      error["trackingId"] = "Tracking ID is required";
      validationStatus = false;
    }
  
    // Validate receipt file (if status is "Shipped")
    if (orderStatus === "2") {
      if (!invoiceFile) {
        error["receipt"] = "Please upload a invoice";
        validationStatus = false;
      } else if (!validFileTypes.includes(invoiceFile.type)) {
        error["receipt"] = "Only PDF files are accepted";
        validationStatus = false;
      } else if (invoiceFile.size > 5 * 1024 * 1024) { 
        error["receipt"] = "File size must be less than 5MB";
        validationStatus = false;
      }
    }
  
    setErrors(error);
    return validationStatus;
  };

  //   Change Order Status Handler
  const changeOrderStatusHandler = async (e) => {
    e.preventDefault();
    const validate = invoiceValidation();
    if (validate) {
    try {  
      setSubmitButton(true);    
      const formData = new FormData();
      formData.append("orderId", id);
      formData.append("trackingId", trackingId);
      formData.append("status", orderStatus);
      formData.append("receipt", invoiceFile);    
      const response = await changeOrderStatusController(formData);
      if (response?.data.code === 200) {
        setStatusModal(false);
        setOrderStatusModal(false);
        setSubmitButton(false);
        toast.success(response?.data?.message);
        fetchViewOrder();
        fetchingOrderLogs()
      } else {
        toast.error(response?.data?.message);
        setStatusModal(false);
        setOrderStatusModal(false);
        setSubmitButton(false);
      }
    } catch (e) {
      setSubmitButton(false);
      setStatusModal(false);
      setOrderStatusModal(false);
    }
  }
  };

  const handleTransactionIdUpdate = async () => {
    try {
      const data = {
        masterOrderId: masterOrderId,
        txnId: transactionId, // Changed from transactionId to txnId
      };

      const response = await updateTransactionIdController(data);

      if (response?.code === 200) {
        setTransactionIdModal(false);
        setTransactionId("");
        toast.success(response?.message);
        fetchViewOrder();
        fetchingOrderLogs();
      } else {
        toast.error(response?.message);
      }
    } catch (e) {
      toast.error("Failed to update transaction ID");
    }
  };

  const handleOrderRemark = async () => {
    try {
      if (!orderRemark) {
        return toast.error("Order remark is required");
      }
      const data = {
        orderId: id,
        remark: orderRemark,
      };

      const response = await updateOrderRemark(data);

      if (response?.code === 200) {
        setOrderRemarkModal(false);
        setOrderRemark("");
        toast.success(response?.message);
        fetchViewOrder();
        fetchingOrderLogs();
      } else {
        toast.error(response?.message);
      }
    } catch (e) {
      toast.error("Failed to Add remark");
    }
  };

  //   Change Order Status Handler
  const cancelOrderHandler = async (e) => {
    e.preventDefault();
    const status = cancelReasonValidation();
    if (status) {
      try {
        setSubmitButton(true);
        const reqData = {
          orderId: id,
          cancelReason: cancelReason || "",
          status: orderStatus,
        };

        const response = await cancelOrderController(reqData);
        if (response?.code === 200) {
          setCancelledModal(false);
          setSubmitButton(false);
          setCancelReason("");
          setErrors("");
          toast.success(response?.message);
          fetchViewOrder();
          fetchingOrderLogs();
        } else {
          toast.error(response?.message);
          setCancelReason("");
          setErrors("");
          setCancelledModal(false);
          setSubmitButton(false);
        }
      } catch (e) {
        setErrors("");
        setSubmitButton(false);
        setCancelledModal(false);
      }
    }
  };

  const refundPaymentHandler = async () => {
    try {
      const data = {
        orderId: Number(id),
      };
      const response = await refundPaymentController(data);
      if (response?.data?.code === 200) {
        setRefundModal(false);
        toast.success(
          response?.data?.message || response?.response?.data?.message
        );
        fetchViewOrder();
        setSubmitButton(false);
      } else {
        toast.error(
          response?.response?.data?.message || response?.data?.message
        );
        setRefundModal(false);
        setSubmitButton(false);
      }
    } catch (e) {
      setSubmitButton(false);
    }
  };
  const statusMapping = {
    1: "Processing",
    2: "Shipped",
    3: "Delivered",
    4: "Cancelled",
  };
  const extractStatusInfo = (value) => {
    if (!value) return { code: value, reason: null };

    const match = value.toString().match(/^(\d+)\s*\(([^)]*)\)?$/);
    if (match) {
      return {
        code: match[1],
        reason: match[2],
      };
    } else {
      return {
        code: value.toString(),
        reason: null,
      };
    }
  };

  useEffect(() => {
    fetchViewOrder();
    fetchingOrderLogs();
  }, []);

  return (
    <React.Fragment>
      <div className="main-panel">
        <div className="content-wrapper">
          <div className="page-header">
            <div className="page_title_wrap">
              <h3 className="page-title">
                <span
                  className="page-title-icon bg-gradient-primary text-white me-2"
                  onClick={() => {
                    navigate(-1);
                  }}
                // Retailer
                >
                  <i className="mdi mdi-chevron-double-left"></i>
                </span>
                View Order / Product Info
              </h3>
              <div className="button_wrap"></div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 text-start mt-4">
              <h4>Order Id : {orderSummary.orderNo}</h4>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 grid-margin stretch-card mt-4">
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>
                            <h4>Product Image</h4>
                          </th>
                          <th>
                            <h4>Item Summary</h4>
                          </th>
                          <th>
                            <h4>Quantity</h4>
                          </th>
                          <th>
                            <h4>Price</h4>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {orderDetail && orderDetail.length > 0 ? (
                          orderDetail.map(
                            (
                              {
                                productDetails,
                                bundleDetails,
                                quantity,
                                orderId,
                                orderNo,
                                totalAmount,
                                amount
                              },
                              index
                            ) => {
                              return (
                                <React.Fragment key={index}>
                                  <tr>
                                    <td>
                                      <img
                                        src={
                                          (bundleDetails?.bundleImages?.[0]?.bundleImage) ??
                                          (productDetails?.productImage?.[0]?.productImage) ??
                                          "assets/images/user.png"
                                          // "https://inventory.zoho.in/DocTemplates_ItemImage_2018802000001100236.zbfs?organization_id=60031457898&image_size=large"
                                        }
                                      // alt={orderId}
                                      />
                                    </td>
                                    <td>
                                      {productDetails
                                        ? productDetails?.productName || "---"
                                        : bundleDetails?.bundleName || "---"}
                                    </td>

                                    <td>{quantity ? quantity : "---"}</td>
                                    <td>{amount ? amount : "---"}</td>
                                  </tr>
                                </React.Fragment>
                              );
                            }
                          )
                        ) : (
                          <tr>
                            <td colSpan={4}>Orders Not Found</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 grid-margin stretch-card mt-4">
              <div className="card">
                <div className="card-body">
                  <div className="row mb-3">
                    <div className="col-6">
                      <h4 className="h4">Order Summary</h4>
                    </div>
                    {orderSummary?.status == 5 ? (
                      <div className="col-6">
                        <p>Refunded</p>
                      </div>
                    ) : (
                      <div className="col-6">
                        <select
                          value={orderSummary?.status}
                          className="form-control"
                          onChange={(e) => orderStatusHandler(e)}
                        >
                          <option value={1}>Order Processing</option>
                          <option value={2}>Shipped</option>
                          <option value={3}>Delivered</option>
                          <option value={4}>Cancelled</option>
                        </select>
                      </div>
                    )}
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <p>Last Updated</p>
                    </div>
                    <div className="col-6">
                      <p>{dateTimeFormat(orderSummary?.updatedAt) || ""}</p>
                    </div>
                  </div>
                  {orderSummary?.trackingId && (
                    <div className="row">
                      <div className="col-6">
                        <p>Tracking Id</p>
                      </div>
                      <div className="col-6">
                        <p>{orderSummary?.trackingId || ""}</p>
                      </div>
                    </div>
                  )}

                  <div className="row">
                    <div className="col-6">
                      <p>Order Created</p>
                    </div>
                    <div className="col-6">
                      <p>{dateFormatYear(orderSummary?.createdAt, "month")}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <p>Order Time</p>
                    </div>
                    <div className="col-6">
                      <p>{timeFormat(orderSummary?.createdAt || "---")}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <p>Item Price</p>
                    </div>
                    <div className="col-6">
                      <p>{orderSummary?.itemAmount}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <p>GST</p>
                    </div>
                    <div className="col-6">
                      <p>{orderSummary.gst ? orderSummary.gst : ""}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <p>COD Charges</p>
                    </div>
                    <div className="col-6">
                      <p>{orderSummary.CODCharges ? orderSummary.CODCharges : 0}</p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-6">
                      <p>Total</p>
                    </div>
                    <div className="col-6">
                      <p>{orderSummary?.totalAmount}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 grid-margin stretch-card mt-4">
              <div className="card">
                <div className="card-body">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>
                          <h4>Customer Details</h4>
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Customer Name:</td>
                        <td>
                          {orderSummary?.masterOrderDetails?.retailerDetails
                            ?.retailerName
                            ? orderSummary?.masterOrderDetails?.retailerDetails
                              ?.retailerName
                            : "---"}
                        </td>
                      </tr>
                      <tr>
                        <td>Mobile Number:</td>
                        <td>
                          {orderSummary?.masterOrderDetails?.retailerDetails
                            ?.mobileNumber
                            ? orderSummary?.masterOrderDetails?.retailerDetails
                              ?.mobileNumber
                            : "---"}
                        </td>
                      </tr>
                      <tr>
                        <td>Email:</td>
                        <td>
                          {orderSummary?.masterOrderDetails?.retailerDetails
                            ?.email
                            ? orderSummary?.masterOrderDetails?.retailerDetails
                              ?.email
                            : "---"}
                        </td>
                      </tr>
                      <tr>
                        <td>Payment Mode</td>
                        <td>
                          {orderSummary?.masterOrderDetails?.transactionType}
                        </td>
                      </tr>
                      <tr>
                        <td>Transaction ID:</td>
                        <td>
                          <div className="flex align-items-center justify-content-between">
                            <span>
                              {orderSummary?.masterOrderDetails?.transactionId
                                ? `${orderSummary.masterOrderDetails?.transactionId.slice(
                                  0,
                                  7
                                )}${orderSummary?.masterOrderDetails
                                  ?.transactionId.length > 7
                                  ? "......."
                                  : ""
                                }`
                                : "---"}
                            </span>
                            {isAdmin && (
                              <button
                                onClick={() => {
                                  setTransactionId(
                                    orderSummary?.masterOrderDetails
                                      ?.transactionId || ""
                                  );
                                  setTransactionIdModal(true);
                                }}
                                className="btn btn-sm"
                                style={{ marginLeft: "4px" }}
                              >
                                <ModeEditIcon fontSize="small" />
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Remark</td>
                        <td>
                          <div className="flex align-items-center justify-content-between">
                            <span>
                              {orderSummary?.orderRemark
                                ? `${orderSummary?.orderRemark.slice(0, 7)}${orderSummary?.orderRemark.length > 7
                                  ? "......."
                                  : ""
                                }`
                                : "---"}
                            </span>
                            <button
                              onClick={() => {
                                setOrderRemark(
                                  orderSummary?.orderRemark || ""
                                );
                                setOrderRemarkModal(true);
                              }}
                              className="btn btn-sm"
                              style={{ marginLeft: "4px" }}
                            >
                              <ModeEditIcon fontSize="small" />
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Payment Mode</td>
                        <td>
                          {orderSummary?.masterOrderDetails?.transactionType}
                        </td>
                      </tr>
                      <tr>
                        <td>Address 1:</td>
                        <td>
                          {orderSummary?.masterOrderDetails?.retailerDetails
                            ?.BussinessDetail?.address1 || "---"}
                        </td>
                      </tr>
                      <tr>
                        <td>Address 2:</td>
                        <td>
                          {orderSummary?.masterOrderDetails?.retailerDetails
                            ?.BussinessDetail?.address2 || "---"}
                        </td>
                      </tr>
                      <tr>
                        <td>City:</td>
                        <td>
                          {orderSummary?.masterOrderDetails?.retailerDetails
                            ?.BussinessDetail?.city || "---"}
                        </td>
                      </tr>
                      <tr>
                        <td>State:</td>
                        <td>
                          {orderSummary?.masterOrderDetails?.retailerDetails
                            ?.BussinessDetail?.state || "---"}
                        </td>
                      </tr>
                      <tr>
                        <td>Pincode:</td>
                        <td>
                          {orderSummary?.masterOrderDetails?.retailerDetails
                            ?.BussinessDetail?.pincode || "---"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="col-lg-12 grid-margin stretch-card mt-4">
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>
                            <h4>Order Logs</h4>
                          </th>
                          <th></th>
                        </tr>
                      </thead>
                      <thead>
                        <tr>
                          <th>Event</th>
                          <th>Action (Reason)</th>
                          <th>Admin Type</th>
                          <th>Name</th>
                          <th>Created At</th>
                        </tr>
                      </thead>
                      <tbody>
                        {totalLogs?.map(
                          (
                            {
                              changedField,
                              previousValue,
                              newValue,
                              createdAt,
                              adminDetails,
                              sellerDetails,
                            },
                            index
                          ) => {
                            let adminType = "";
                            let name = "";
                            if (adminDetails) {
                              adminType = "Admin";
                              name = adminDetails.name;
                            } else if (sellerDetails) {
                              adminType = "Seller";
                              name = sellerDetails.sellerName;
                            }
                            const prevInfo = extractStatusInfo(previousValue);
                            const newInfo = extractStatusInfo(newValue);

                            const previousStatusName =
                              statusMapping[prevInfo.code] || prevInfo.code;
                            const newStatusName =
                              statusMapping[newInfo.code] || newInfo.code;
                            return (
                              <tr key={++index}>
                                <td>
                                  {" "}
                                  {changedField === "status"
                                    ? "Status Updated"
                                    : changedField}
                                </td>
                                <td>
                                  {previousStatusName || "---"}{" "}
                                  <span className="arrow"></span>{" "}
                                  {newStatusName}{" "}
                                  {newInfo.reason && (
                                    <span className="text-gray-500 ml-2">
                                      ({newInfo.reason})
                                    </span>
                                  )}
                                </td>
                                <td>{adminType}</td>
                                <td>{name}</td>
                                <td>{new Date(createdAt).toLocaleString()}</td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {schemeDetail && schemeDetail.length > 0 && (
              <>
                <h2 className="page-title text-start mt-4">Scheme</h2>
                <div className="row">
                  <div className="col-lg-6 grid-margin stretch-card mt-4">
                    <div className="card">
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th>
                                  <h4>Product Name</h4>
                                </th>
                                <th>
                                  <h4>Price</h4>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {schemeDetail && schemeDetail.length > 0
                                ? schemeDetail.map(
                                  ({ productDetail }, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <tr>
                                          {/* <td>
                                      <img
                                        src={
                                          productDetails?.productImage[0]
                                            ?.productImage
                                            ? productDetails?.productImage[0]
                                                ?.productImage
                                            : "assets/images/user.png"
                                        }
                                        // alt={orderId}
                                      />
                                    </td> */}
                                          <td>
                                            {productDetail?.productName
                                              ? productDetail.productName
                                              : "---"}
                                          </td>
                                          <td>
                                            {productDetail?.netPrice
                                              ? productDetail.netPrice
                                              : "---"}
                                          </td>
                                        </tr>
                                      </React.Fragment>
                                    );
                                  }
                                )
                                : null}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {Number(orderSummary.status) === 4 && (
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>
                            <h4>Image</h4>
                          </th>
                          <th>
                            <h4>Reason</h4>
                          </th>
                          <th>Total Price</th>
                          {orderSummary?.walletAmount !== 0 &&
                            orderSummary?.status !== 5 && <th>Action</th>}
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <img
                              src={
                                orderSummary.cancelImage
                                  ? orderSummary.cancelImage
                                  : "./assets/images/user.png"
                              }
                              alt=""
                            />
                          </td>
                          <td>
                            {orderSummary?.cancelReason.length > 30 ? (
                              <>
                                {orderSummary?.cancelReason.slice(0, 30)}{" "}
                                <Link
                                  onClick={() => {
                                    setCancelDescription(
                                      orderSummary?.cancelReason
                                    );
                                    setCancelDescriptionModal(true);
                                  }}
                                  to="#"
                                >
                                  see more
                                </Link>
                              </>
                            ) : (
                              orderSummary?.cancelReason
                            )}
                          </td>

                          <td>{orderSummary.totalAmount}</td>
                          {orderSummary?.walletAmount !== 0 &&
                            orderSummary?.status !== 5 && (
                              <td>
                                <Link
                                  to="#"
                                  className="btn btn-outline-primary cstm_btn_wrap_theme me-2"
                                  onClick={() => setRefundModal(true)}
                                >
                                  Refund Payment
                                </Link>
                              </td>
                            )}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <ModalBox
          status={statusModal}
          onClose={() => {
            setStatusModal(false);
            setTrackingId("");
          }}
          title="Tracking Id"
          customizedFooter={<></>}
        >
          <React.Fragment>
            <div className="card">
              <div className="card-body">
                <form className="forms-sample">
                  <div className="form-group">
                    <label htmlFor="Banner">Enter Tracking Id <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputName1"
                      value={trackingId}
                      name="trackingId"
                      placeholder="Enter Tracking Id"
                      onChange={(e) => setTrackingId(e.target.value)}
                    />
                     <div className="form-group mt-3">
            <label htmlFor="invoice">Upload Invoice (PDF only) <span className="text-danger">*</span></label>
            <input
              type="file"
              className="form-control"
              id="invoice"
              accept=".pdf"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file && file.type === "application/pdf") {
                  setInvoiceFile(file);
                  setInvoiceError("");
                } else {
                  setInvoiceFile(null);
                  setInvoiceError("Please upload a PDF file");
                }
              }}
            />
            {invoiceError && <div className="text-danger">{invoiceError}</div>}
            <span style={{ color: "red" }} className="error">
                      {typeof errors === "object"
                        ? Object.values(errors).join(", ")
                        : errors}
                    </span>
          </div>
                    <div className="d-flex justify-content-center align-items-center mt-4">
                      <button
                        type="submit"
                        className="btn btn-gradient-primary me-2"
                        onClick={(e) => {
                          changeOrderStatusHandler(e);
                        }}
                        ref={submitButton}
                      >
                        Submit
                      </button>
                      <button
                        className="btn btn-light"
                        onClick={(e) => {
                          setStatusModal(false);
                          setTrackingId("");
                          e.preventDefault();
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </React.Fragment>
        </ModalBox>

        {/* Cancel Reason Modal*/}
        <ModalBox
          status={CancelledModal}
          onClose={() => {
            setCancelledModal(false);
            setCancelReason("");
            setErrors("");
          }}
          title="Cancel Order"
          customizedFooter={<></>}
        >
          <React.Fragment>
            <div class="card">
              <div class="card-body">
                <form class="forms-sample">
                  <div class="form-group">
                    <label htmlFor="Banner ">
                      Enter Cancel Reason <span className="text-danger">*</span>
                    </label>
                    <textarea
                      type="text"
                      class="form-control"
                      id="exampleInputName1"
                      cols={4}
                      value={cancelReason}
                      name="cancelReason"
                      placeholder="Enter cancel reason"
                      onChange={(e) => setCancelReason(e.target.value)}
                    />
                    <span style={{ color: "red" }} className="error">
                      {typeof errors === "object"
                        ? Object.values(errors).join(", ")
                        : errors}
                    </span>
                    <div className="d-flex justify-content-center align-items-center mt-4">
                      <button
                        type="submit"
                        class="btn btn-gradient-primary me-2"
                        onClick={(e) => {
                          cancelOrderHandler(e);
                        }}
                        ref={submitButton}
                      >
                        Submit
                      </button>
                      <button
                        class="btn btn-light"
                        onClick={(e) => {
                          setCancelledModal(false);
                          e.preventDefault();
                          setCancelReason("");
                          setErrors("");
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </React.Fragment>
        </ModalBox>

        {/* Order Status Modal */}
        <ModalBox
          status={orderStatusModal}
          onClose={() => setOrderStatusModal(false)}
          title="Change Status"
          description="Are you sure you want to change the status of order"
          action={changeOrderStatusHandler}
          uploadButtonElement={submitButton}
        />

        <ModalBox
          status={cancelDescriptionModal}
          onClose={() => setCancelDescriptionModal(false)}
          title="Cancel Reason"
          customizedFooter={<></>}
        >
          <div>
            <p className="text-center">{cancelDescription}</p>
          </div>
        </ModalBox>
        <ModalBox
          status={transactionIdModal}
          onClose={() => {
            setTransactionIdModal(false);
            setTransactionId("");
          }}
          title="Update Transaction ID"
          customizedFooter={<></>}
        >
          <div className="card">
            <div className="card-body">
              <form className="forms-sample">
                <div className="form-group">
                  <label htmlFor="transactionId">
                    Enter New Transaction ID
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="transactionId"
                    value={transactionId}
                    placeholder="Enter new transaction ID"
                    onChange={(e) => setTransactionId(e.target.value)}
                  />
                  <div className="d-flex justify-content-center align-items-center mt-4">
                    <button
                      type="button"
                      className="btn btn-gradient-primary me-2"
                      onClick={handleTransactionIdUpdate}
                      ref={submitButton}
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      className="btn btn-light"
                      onClick={() => {
                        setTransactionIdModal(false);
                        setTransactionId("");
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </ModalBox>

        {/* Modal for order remark */}
        <ModalBox
          status={orderRemarkModal}
          onClose={() => {
            setOrderRemarkModal(false);
            setOrderRemark("");
          }}
          title="Update Order Remark"
          customizedFooter={<></>}
        >
          <div className="card">
            <div className="card-body">
              <form className="forms-sample">
                <div className="form-group">
                  <label htmlFor="orderRemark">
                    Enter Order Remark
                  </label>
                  <textarea
                    type="text"
                    className="form-control"
                    id="orderRemark"
                    value={orderRemark}
                    placeholder="Enter Order Remark"
                    onChange={(e) => setOrderRemark(e.target.value)}
                    rows={3}
                    style={{
                      resize: "vertical",
                      maxHeight: "200px"
                    }}
                  />
                  <div className="d-flex justify-content-center align-items-center mt-4">
                    <button
                      type="button"
                      className="btn btn-gradient-primary me-2"
                      onClick={handleOrderRemark}
                      ref={submitButton}
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      className="btn btn-light"
                      onClick={() => {
                        setOrderRemarkModal(false);
                        setOrderRemark("");
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </ModalBox>

        <ModalBox
          status={refundModal}
          onClose={() => setRefundModal(false)}
          title="Refund Payment"
          description="Are you sure you want to refund payment of this order?"
          action={refundPaymentHandler}
          uploadButtonElement={submitButton}
        />
      </div>
    </React.Fragment>
  );
}

export default ViewOrder;
